import { Icon } from "./Icon";
import type { IconName } from "./Icon";

export type SocialIconName =
  | "TikTok"
  | "Instagram"
  | "YouTube"
  | "Facebook"
  | "X"
  | "Discord"
  | "VKVideo"
  | "Telegram"
  | "Email";

const NAME_MAP: Record<SocialIconName, IconName> = {
  TikTok: "tiktok",
  Instagram: "instagram",
  YouTube: "youtube",
  Facebook: "facebook",
  X: "x",
  Discord: "discord",
  VKVideo: "vk",
  Telegram: "telegram",
  Email: "email",
};

type Props = {
  name: SocialIconName;
};

/**
 * Social media glyph. Size/color come from the parent's font-size / text color
 * (see Icon). Decorative by default — wrap with an accessible label at the call site.
 */
export function SocialIcon({ name }: Props) {
  return <Icon name={NAME_MAP[name]} />;
}
